<template>
  <v-card
    v-if="loading"
    tile
    flat
    :dark="dark"
    class="page-scene-loader"
  >
    <div
      class="page-scene-loader__logo"
      :class="{ _dark: dark }"
    >
      <img
        :src="logo"
        width="100"
        height="100"
        alt="growmindgrow-logo"
        class="page-scene-loader__logo-image"
      >
      <v-card-title class="page-scene-loader__logo-title">GrowMindGrow</v-card-title>
    </div>

    <div class="page-scene-loader__content">
      <v-progress-circular
        :value="loadingProgress"
        :indeterminate="!hasLoadingProgressData"
        :rotate="hasLoadingProgressData ? 270 : 0"
        :size="100"
        :width="15"
        :color="color"
      >
        <span v-if="hasLoadingProgressData" class="font-weight-medium">
          {{ loadingProgress }}%
        </span>
      </v-progress-circular>
      <div class="font-weight-medium mt-4">{{ loadingTitle }}</div>
    </div>
  </v-card>
</template>

<script>
const logo = require('../../phaser-assets/images/views/intro/logo.svg');

export default {
  name: 'PageSceneLoader',
  props: {
    scene: {
      type: Object,
      required: true,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      logo,
    };
  },
  computed: {
    loading() {
      if (this.fontLoading) return true;
      if (!this.loadingTexturesProgress) return false;
      const { completed, failed, total } = this.loadingTexturesProgress;
      return !(total === (completed + failed) && this.loadingProgress === 100);
    },
    loadingProgress() {
      if (this.fontLoading || !this.scene?.progress) return null;
      return Math.ceil(this.scene?.progress * 100);
    },
    fontLoading() {
      return this.scene?.fontLoading;
    },
    hasLoadingProgressData() {
      return Number.isInteger(this.loadingProgress);
    },
    loadingTitle() {
      return (this.fontLoading ? this.loadingFontTitle : this.loadingImagesTitle) || 'Preparing...';
    },
    loadingImagesTitle() {
      if (!this.loadingTexturesProgress) return null;
      const { completed, failed, total } = this.loadingTexturesProgress;
      if (!total) return null;
      const optionalFailedData = failed ? `(${failed} failed)` : '';
      const progress = `${completed + failed}/${total} ${optionalFailedData}`;
      return `Loading textures: ${progress}`;
    },
    loadingFontTitle() {
      return 'Waiting for all fonts to be loaded';
    },
    loadingTexturesProgress() {
      if (!this.scene) return null;
      return {
        completed: this.scene?.load.totalComplete,
        failed: this.scene?.load.totalFailed,
        total: this.scene?.load.totalToLoad,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.page-scene-loader {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &__logo {
    position: absolute;
    top: 10%;
    left: 10%;
    display: flex;
    align-items: center;
  }

  &__logo-title {
    font-size: 2rem;
  }

  &__logo._dark &__logo-image {
    filter: invert(1);
  }

  &__content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media screen and (max-width: 600px) {
  .page-scene-loader {
    &__logo {
      left: 0;
      width: 100%;
      justify-content: center;
    }
  }
}
</style>
